import { BuiText } from "@btnet/blueprint-components";

import { type IBTTextProps } from "./BTText.types";

/**
 * BTText — the app-level text component.
 *
 * A thin wrapper around BuiText (the Blueprint typography primitive) that gives the
 * app a stable import surface from `@btnet/core-components`. Props mirror BuiText:
 * pass `children` (preferred) or `text`, and control typography with `size`. Sizes
 * starting with `normal-*` render as inline spans; `distinct-*` and `heavy-*` render
 * as block-display header tags. Use `tag` to override the default element.
 *
 * @example
 * <BTText size="heavy-md">Section heading</BTText>
 */
export function BTText(props: IBTTextProps) {
  return <BuiText {...props} />;
}
